import { VIDEO_DOWNLOAD_EVENTS } from 'Sp/Angular/Events/Client/Gallery';
import Route from 'Sp/Route';

export default [
    '$rootScope',
    'spApiHttp',
    function VideoDownloadDataStore($rootScope, spApiHttp) {
        $rootScope.$on(VIDEO_DOWNLOAD_EVENTS.CREATE, createVideoDownload);

        function createVideoDownload(_, request) {
            const { albumId } = request;
            const eventId = $rootScope.eventData.publicId
                ? $rootScope.eventData.publicId
                : $rootScope.eventData.id;
            const apiRouteParams = {
                brandId: $rootScope.brandData.id,
                eventId,
                photoId: request.photoId
            };
            let apiRoute;

            if (albumId) {
                apiRouteParams.albumId = albumId;
                apiRoute = '/brand/:brandId/event/:eventId/album/:albumId/video/:photoId/download';
            } else {
                apiRoute = '/brand/:brandId/event/:eventId/video/:photoId/download';
            }

            spApiHttp
                .post({
                    url: Route.get(apiRoute, apiRouteParams),
                    data: {
                        type: 'download-request',
                        digitalRuleId: request.digitalRuleId,
                        email: request.email,
                        pins: request.pins
                    },
                    headers: {
                        Authorization: `Bearer ${request.authorizationToken}`
                    }
                })
                .then(({ data: videoDownload }) => {
                    $rootScope.$broadcast(VIDEO_DOWNLOAD_EVENTS.CREATED, videoDownload);
                })
                .catch(({ data, status }) => {
                    if (status === 403 && data.detail === 'The provided token is expired.') {
                        return $rootScope.$broadcast(
                            VIDEO_DOWNLOAD_EVENTS.ERRORS.TOKEN_INVALID,
                            albumId
                        );
                    }

                    if (status === 503) {
                        return $rootScope.$broadcast(VIDEO_DOWNLOAD_EVENTS.ERRORS.TIMEOUT);
                    }

                    const { errors = {} } = data.info;

                    if (errors.digitalRuleId && errors.digitalRuleId.notInEventAlbum) {
                        $rootScope.$broadcast(VIDEO_DOWNLOAD_EVENTS.ERRORS.ALBUM);
                    }

                    if (errors.pin && errors.pin.notInDigitalRule) {
                        $rootScope.$broadcast(VIDEO_DOWNLOAD_EVENTS.ERRORS.PIN);
                    }
                });
        }
    }
];
